<table class="table table-bordered container mt-5 mb-5">
  <thead>
    <tr>
      <th scope="col">Sl No</th>
      <th scope="col">Financial Year</th>
      <th scope="col">Name of the Scheme</th>
      <th scope="col">Target</th>
      <th scope="col">Completed</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>2016-17</td>
      <td>PMAY(G)</td>
      <td>90</td>
      <td>90</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>2017-18</td>
      <td>PMAY(G)</td>
      <td>84</td>
      <td>84</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>2018-19</td>
      <td>PMAY(G)</td>
      <td>36</td>
      <td>36</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>2019-20</td>
      <td>PMAY(G)</td>
      <td>221</td>
      <td>213</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>2020-21</td>
      <td>PMAY(G)</td>
      <td>103</td>
      <td>91</td>
    </tr>
  </tbody>
</table>

<table class="table table-bordered container mt-5 mb-5">
  <thead>
    <tr>
      <th scope="col">Sl No</th>
      <th scope="col">Financial Year</th>
      <th scope="col">Name of the Scheme</th>
      <th scope="col">Target</th>
      <th scope="col">Completed</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>2016-17</td>
      <td>BPGY</td>
      <td>10</td>
      <td>09</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>2017-18</td>
      <td>BPGY</td>
      <td>Nil</td>
      <td>Nil</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>2018-19</td>
      <td>BPGY</td>
      <td>09</td>
      <td>09</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>2019-20</td>
      <td>BPGY</td>
      <td>Nil</td>
      <td>Nil</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>2020-21</td>
      <td>BPGY</td>
      <td>Nil</td>
      <td>Nil</td>
    </tr>
  </tbody>
</table>
